/*
 * @Author: your name
 * @Date: 2021-04-14 14:47:17
 * @LastEditTime: 2023-03-28 13:32:01
 * @LastEditors: Json Chen
 * @Description: In User Settings Edit
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/ListPage/tools.ts
 */

const convertDataFromServerToRedux = (response) => {
  const {
    productContent = {},
    product = {},
    aliases = [],
    salesChannel = {},
  } = response || {};
  const { uuid = '' } = product;
  const { uuid: salesChannelUuid = '', name: salesChannelName = '' } =
    salesChannel;
  const { uuid: contentUuid = '', productName = '' } = productContent;

  const aliasData = (aliases || []).map((item) => {
    return {
      uuid: item.uuid,
      contentDetails: { productName: item.productName },
      salesChannelProductUuid: uuid,
      contentUuid,
    };
  });

  const data = {
    salesChannelProductUuid: uuid,
    salesChannelUuid,
    hasModified: false,
    contentUuid,
    productName,
    salesChannelName,
    alias: aliasData || [],
  };
  return data;
};

const duplicateConvertDataFromReduxToServer = (data) => {
  const { uuid, contentUuid = '', productName } = data;
  return {
    contentUuid,
    uuid: uuid,
    productName,
    salesChannelProductUuid: contentUuid,
  };
};

const duplicateConvertDataFromServerToRedux = (response) => {
  const { uuid, productName } = response;
  const aliasData = {
    uuid,
    contentDetails: { productName },
    salesChannelProductUuid: uuid,
    contentUuid: uuid,
  };
  return aliasData;
};

export {
  convertDataFromServerToRedux,
  duplicateConvertDataFromReduxToServer,
  duplicateConvertDataFromServerToRedux,
};
